import type { PdfProps, Report, StaticSection } from 'features/reporting/types'
import { CustomSectionPages } from 'pages/reporting/reports/rug/components/CustomSectionPages'
import { rugReportForSPA } from 'pages/reporting/reports/rug/rugReport'
import type { SectionAddendum } from 'pages/reporting/reports/rug/rugReportData'
import React from 'react'

export function buildRugReport(addendums: SectionAddendum[]): Report {
  if (addendums.length === 0) return rugReportForSPA
  const sectionIds = new Set(
    rugReportForSPA.sections.map((section) => section.id)
  )
  const custom = new Map<string, SectionAddendum[]>()
  for (const addendum of addendums) {
    if (!sectionIds.has(addendum.sectionId)) {
      const group = custom.get(addendum.sectionId) ?? []
      custom.set(addendum.sectionId, [...group, addendum])
    }
  }
  const staticSections: StaticSection[] = [...custom].map(
    ([sectionId, group]) => ({
      id: sectionId,
      title: sectionId,
      RenderPDF: (props: PdfProps) =>
        React.createElement(CustomSectionPages, {
          sectionId,
          sectionTitle: sectionId,
          addendums: group,
          onRender: props.onRender,
        }),
    })
  )
  return {
    ...rugReportForSPA,
    staticSections: [...staticSections, ...rugReportForSPA.staticSections],
  }
}
